import { utils } from './utils';
import { bridge } from './bridge';
import { locals } from './locals';

export const PCStoreJsBridge = { ...utils, ...bridge, ...locals };
